module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "tra"
    }
  }), _vm._v("Note on Transliteration")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLITERATION SYSTEMS ATTEMPT")]), _vm._v(", and repeatedly fail, to assimilate different written languages. Transcribing Moroccan dialectal Arabic ("), _c('em', [_vm._v("darija")]), _vm._v("), standard Arabic, and French provides multiple such opportunities. In aiming for imperfect assimilation, I use two diacritical marks for darija and standard Arabic, "), _c('sup', [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/lsquo.jpg"
    }
  })]), _vm._v(" for "), _c('sup', [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/lsquo.jpg"
    }
  })]), _vm._v("ayn, and "), _c('sup', [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/rsquo.jpg"
    }
  })]), _vm._v(" for hamza. I quote different French and English versions of Arabic terms as they appear in original sources (Aïssaoua, Aïssâoua, and "), _c('sup', [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "image",
      "src": "images/lsquo.jpg"
    }
  })]), _vm._v("Isawa; Sidi Mohammed and Muhammad V). Other names of known figures and place names appear as they are commonly recognized in English (the prophet Muhammad, the city of Fez).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43395eab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/transliteration.vue
// module id = 78
// module chunks = 0